import { render, staticRenderFns } from "./detailOrder.vue?vue&type=template&id=07cdb776&scoped=true&"
import script from "./detailOrder.vue?vue&type=script&lang=js&"
export * from "./detailOrder.vue?vue&type=script&lang=js&"
import style0 from "./detailOrder.vue?vue&type=style&index=0&id=07cdb776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cdb776",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCol,VRow,VSimpleTable,VTextarea})
